import React from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { bioreactorByIdSelector } from "../../../../store/global/global.selectors";
import ReactorImg from "../../../../images/default-bioreactor.svg";
import * as styles from "./styles.module.scss";
const BioreactorImage = ({ bioreactorId, modalVersionsPopUp, changeModalVersionsPopUp, className, size, }) => {
    const { image, description } = useSelector(bioreactorByIdSelector(bioreactorId));
    return (React.createElement("button", { onClick: () => {
            changeModalVersionsPopUp && changeModalVersionsPopUp(!modalVersionsPopUp);
        } }, image ? (React.createElement("img", { src: `data:image/png;base64,${image}`, className: classNames(styles.bioreactorImg, className), style: { width: size, height: size }, alt: description })) : (React.createElement(ReactorImg, { className: classNames(styles.bioreactorImg, className), style: { width: size, height: size } }))));
};
export default BioreactorImage;
